<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import ContactDetailsItem from '../ContactDetailsItem.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import ProductsAPI from 'dashboard/api/crm/products';

const { t } = useI18n();
const products = ref([]);
const isLoading = ref(false);

const loadProducts = async () => {
  isLoading.value = true;
  try {
    const response = await ProductsAPI.get({ active: 'true' });
    products.value = response.data || [];
  } catch (error) {
    useAlert(t('CONTACT_PANEL.PRODUCTS.LOAD_ERROR'));
  } finally {
    isLoading.value = false;
  }
};

const onCopyPrice = async (product) => {
  const text = `${product.currency} ${product.price}`;
  await copyTextToClipboard(text);
  useAlert(t('CONTACT_PANEL.COPY_SUCCESSFUL'));
};

onMounted(() => {
  loadProducts();
});
</script>

<template>
  <div v-if="isLoading" class="text-sm text-n-slate-11 p-4">
    {{ t('CONTACT_PANEL.PRODUCTS.LOADING') }}
  </div>
  <div v-else-if="!products.length" class="text-sm text-n-slate-11 p-4">
    {{ t('CONTACT_PANEL.PRODUCTS.NO_DATA') }}
  </div>
  <div v-else class="flex flex-col">
    <ContactDetailsItem
      v-for="product in products"
      :key="product.id"
      :title="product.name"
      :value="product.formatted_price"
    >
      <template #button>
        <NextButton
          ghost
          xs
          slate
          icon="i-lucide-clipboard"
          @click="onCopyPrice(product)"
        />
      </template>
    </ContactDetailsItem>
  </div>
</template>
